export * from './userRoles'
// export const STORAGE_PREFIX = process.env.REACT_APP_STORAGE_PREFIX as string
export const STORAGE_PREFIX = 'web_app_telhacerta'
export const NO_IMAGE = 'http://localhost:4000/files/no-image.jpg'

// export const JWT_SECRET = process.env.REACT_APP_JWT_SECRET as string
// export const API_URL = process.env.REACT_APP_API_URL as string
// export const API_URL = 'http://localhost:4000'
export const API_URL = 'https://apipedidos.telhacerta.com.br'

// export const API_URL = `https://9033-45-7-188-212.sa.ngrok.io`

export const ATTACHMENT_SIZE_LIMIT = 25000000

export const quantityIds = ['COM', 'COL']
